// JavaScript transcription: Chuck England
// Daniel Shiffman
// http://youtube.com/thecodingtrain
// http://codingtra.in

// Coding Challenge #113: 4D Hypercube
// https://youtu.be/XE3YDVdQSPo

// Matrix Multiplication
// https://youtu.be/tzsgS19RRc8
import { Point4D } from './Point4D.js';

function vecToMatrix(v) {
  let m = [];
  for (let i = 0; i < 3; i++) {
    m[i] = [];
  }
  m[0][0] = v.x;
  m[1][0] = v.y;
  m[2][0] = v.z;
  return m;
}

function vec4ToMatrix(v) {
  let m = vecToMatrix(v);
  m[3] = [];
  m[3][0] = v.w;
  return m;
}

function arrToMatrix(arr) {
  let m = [];
  for (let i = 0; i < 4; i++) {
    m[i] = [];
  }
  m[0][0] = arr[0];
  m[1][0] = arr[1];
  m[2][0] = arr[2];
  m[3][0] = arr[3];
  return m;
}

function matrixToVec(m) {
  return createVector(m[0][0], m[1][0], m[2][0]);
}

function matrixToVec4(m) {
  let r = new Point4D(m[0][0], m[1][0], m[2][0], 0);
  if (m.length > 3) {
    r.w = m[3][0];
  }
  return r;
}

function logMatrix(m) {
  const cols = m[0].length;
  const rows = m.length;
  // console.log(rows + 'x' + cols);
  // console.log('----------------');
  let s = '';
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      s += m[i][j] + ' ';
    }
    // console.log(s);
  }
}

function matmulvec(a, vec) {
  let m = vecToMatrix(vec);
  let r = matmul(a, m);
  return matrixToVec(r);
}

function matmulvec4(a, vec) {
  let m = vec4ToMatrix(vec);
  let r = matmul(a, m);
  return matrixToVec4(r);
}

export const matmul = (a, b) => {
  // if (b instanceof p5.Vector) {
  //   return matmulvec(a, b);
  // }
  if (b instanceof Point4D) {
    return matmulvec4(a, b);
  }

  let m = arrToMatrix(b);
  let colsA = a[0].length;
  let rowsA = a.length;
  let colsB = m[0].length;
  let rowsB = m.length;

  if (colsA !== rowsB) {
    console.error('Columns of A must match rows of B');
    return null;
  }

  let result = [];
  for (let j = 0; j < rowsA; j++) {
    result[j] = [];
    for (let i = 0; i < colsB; i++) {
      let sum = 0;
      for (let n = 0; n < colsA; n++) {
        sum += a[j][n] * m[n][i];
      }
      result[j][i] = sum;
    }
  }
  return result;
};
